import { useMutation, useQuery } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import { gql } from "apollo-boost";
import { get } from "lodash";
import React, { useCallback, useRef } from "react";
import { FULFILLMENTS_SLUG, SETTING_VARIABLES } from "../../../constants";
import { useAppContext } from "../../../context";
import { CREATE_FULFILLMENT_CONFIGURE_WITH_STORES } from "../../../graphql/mutations";
import { arrInvalid, getTeamID, handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";
import { useSelectRowsCtx } from "../SelectRowsProvider";
import PrintifyFC from "./PrintifyFC";

const VARIABLES_QUERY = gql`
  query variables($filter: VariableFilter) {
    variables(filter: $filter) {
      id
      key
      value
    }
  }
`;

function BulkConfigFulfillment({
  open,
  onClose,
  idsChecked,
  onCompleted: onCompletedProp,
}) {
  const { toggleToast, setNotify } = useToastContext();
  const { ids, onCompleted } = useSelectRowsCtx();
  const { currentUser } = useAppContext();
  const teamId = getTeamID(currentUser);

  const [enableConfig, setEnableConfig] = React.useState(false);

  useQuery(VARIABLES_QUERY, {
    onCompleted: (res) => {
      const nodes = get(res, "variables") || [];
      const obj = {};
      for (let node of nodes) {
        if (!node || !node.key || !node.value) continue;
        obj[node.key] = node.value;
      }
      let teamIds = obj[SETTING_VARIABLES.FC] || "";
      if (teamIds && typeof teamIds === "string") {
        teamIds = JSON.parse(teamIds);
      }

      if (!arrInvalid(teamIds)) {
        setEnableConfig(teamIds.includes(teamId));
      }
    },
    onError: () => {},
    variables: {
      filter: { search: SETTING_VARIABLES.FC },
    },
  });

  const [createConfig, { loading }] = useMutation(
    CREATE_FULFILLMENT_CONFIGURE_WITH_STORES,
    {
      onCompleted: () => {
        setNotify({
          msg: "Create fulfillment config for this store success.",
          err: false,
        });
        onCompleted && onCompleted();
        onCompletedProp && onCompletedProp();
      },
      onError: (err) => {
        setNotify({ msg: handleError(err?.toString()), err: true });
      },
    },
  );

  const form = useRef(null);
  const handleSubmit = useCallback(() => {
    let mIds = [];
    if (idsChecked?.length > 0) {
      mIds = [...idsChecked];
    } else if (ids?.length > 0) {
      mIds = [...ids];
    }

    if (arrInvalid(mIds)) return;

    const input = form.current ? form.current.onSubmit() : null;

    if (input) {
      toggleToast && toggleToast(true);
      setNotify && setNotify({ msg: null, err: false });
      createConfig({
        variables: {
          input: {
            fulfillmentId: FULFILLMENTS_SLUG.Printify,
            mbStoreIds: mIds,
            ...input,
          },
        },
      });
    }
  }, [createConfig, ids, idsChecked, setNotify, toggleToast]);

  return (
    <Modal
      title="Config Printify fulfillment"
      sectioned
      open={open}
      onClose={onClose}
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loading,
      }}
      secondaryActions={[{ content: "Cancel", onAction: onClose }]}
    >
      {enableConfig ? (
        <PrintifyFC ref={form} />
      ) : (
        <p>Your team does not have this privilege</p>
      )}
    </Modal>
  );
}

export default BulkConfigFulfillment;
